import React from 'react';
import { HiOutlineCube } from 'react-icons/hi2';

interface ShortagesProps {
  shortages: any[];
}

const Shortages: React.FC<ShortagesProps> = ({ shortages }) => {
  const formatDate = (d?: string) => {
    if (!d) return '';
    const date = new Date(d);
    return new Intl.DateTimeFormat('es-CL', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }).format(date);
  };

  return (
    <div className="mp-table-card">
      <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
        <table className="mp-table">
          <thead className="mp-table-head">
            <tr>
              <th>Fecha</th>
              <th>Unidad</th>
              <th>Cantidad</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody className="mp-table-body">
            {shortages && shortages.length > 0 ? (
              shortages.map((s: any) => (
                <tr key={s.shortage_id}>
                  <td>
                    <div style={{ fontSize: '0.875rem', fontWeight: 500, color: 'var(--text-color)' }}>{formatDate(s.local_timestamp || s.timestamp).split(',')[0]}</div>
                    <div style={{ fontSize: '0.75rem', color: 'var(--text-color)', opacity: 0.5 }}>{formatDate(s.local_timestamp || s.timestamp).split(',')[1]}</div>
                  </td>
                  <td style={{ fontSize: '0.875rem', color: 'var(--text-color)' }}>{s.storage_unit_name}</td>
                  <td>
                    <span style={{ fontWeight: 700, color: 'var(--text-color)' }}>{s.quantity}</span>{' '}
                    <span style={{ fontSize: '0.75rem', color: 'var(--text-color)', opacity: 0.5 }}>{s.unidad_medida_name}</span>
                  </td>
                  <td>
                    <span className={s.solved ? 'mp-badge-success' : 'mp-badge-warning'} style={{ display: 'inline-block', padding: '2px 8px', borderRadius: '6px', fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.02em' }}>
                      {s.solved ? 'Resuelto' : 'Pendiente'}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} style={{ padding: 0, border: 'none' }}>
                  <div className="mp-empty-state">
                    <HiOutlineCube className="mp-empty-state-icon" />
                    <div className="mp-empty-state-title">Sin quiebres registrados</div>
                    <p style={{ fontSize: '0.875rem', color: 'var(--text-color)', opacity: 0.5 }}>No se han registrado quiebres de stock para este ingrediente</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {shortages && shortages.length > 0 && (
        <div className="mp-table-footer">
          <span style={{ fontSize: '0.75rem', color: 'var(--text-color)', opacity: 0.5 }}>{shortages.length} quiebre{shortages.length !== 1 ? 's' : ''}</span>
        </div>
      )}
    </div>
  );
};

export default Shortages;
